<template>
  <v-container style="padding-bottom:0px">
    <v-expansion-panels class="mt-4">
      <v-expansion-panel id="pricing-panel">
        <v-expansion-panel-title>Pricing and Billing</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="accordion-container">
            <p style="color:grey;font-weight:bold;font-style:italic">Our goal is to keep things simple. Here's what you get and what it costs:</p>

            <h2>Base Company Account</h2>
            <p>Your company account costs $1,500 monthly This includes:</p>
            <ul>
              <li>A main company phone number that can handle up to 10+ calls at once</li>
              <li>One administrator account with its own phone number</li>
            </ul>

            <h2>Adding More Agents or Underwriters</h2>
            <p>When you need to add agents or underwriters, you have two payment options:</p>
            <ul>
              <li>Daily rate: $40 per user</li>
              <li>Monthly rate: $1,000 per user</li>
            </ul>

            <h2>Call Charges</h2>
            <p>All calls cost 12.5 cents per minute. We round every call to the nearest minute.</p>

            <h2>Text Messages</h2>
            <p>Text message notifications are included at no extra charge.</p>

            <h2>Important Features</h2>
            <ul>
              <li>Every user gets their own phone number</li>
              <li>The system handles:
                <ul>
                  <li>Incoming calls from jail facilities</li>
                  <li>Voice messages from outside callers</li>
                  <li>Live call monitoring by agents</li>
                </ul>
              </li>
            </ul>

            <h2>Account Sharing</h2>
            <p>Yes, users can share accounts. It doesn't really work to have two people sharing an account at the same time. But you could have one account shared between day and night shifts.</p>

            <h2>Billing</h2>
            <p>Billing happens on the 1st of each month. You can choose between being billed by invoice or autopay. Invoices are due within seven days. Each month you will receive a clearly itemized invoice detailing your charges.</p> 

            <h2>Lowest Cost Billing Policy</h2>
            <p>When you add or a delete a user you will be charged $40/day or $1000/month, whichever is less. For example, if you added a user on the 20th of the month, you would be charged $40 * 10 days = $400
            since that is less than $1000. At the beginning of the month you will be charged the monthly account fee of $1500 plus the monthly per additional user fee of $1000. If you delete a user on the 5th
            of the month, for example, you would be charged 5 days * $40/day = $200. You would be refunded $800. The same thing is true for the base account fee. If you opened an account on the 1st of the month
            and cancelled your entire account on the 12th of the month, your charge would be pro-rated to twelve days and you would receive a refund for the over payment. <b>Refunds are issued on the 1st day
            of the month following any user deletions or account cancellations.</b></p>

            <h2>Cancellation</h2>
            <p>To cancel an additional user simply delete them from the Company Account tab. To delete your entire account, please email <b>support@BailBondAgentServices.com</b>. We will verify your intention
            with a phone call, and cease billing as of the day we receive your request.</p>

          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: 'CompanyAccountPricingAndBilling'
};
</script>

<style scoped>
.accordion-container {
  background-color: #f5f5dc;
  padding: 20px;
  border-radius: 8px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 1.1rem;
  font-weight: 600;
}

p {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
}

ul {
  margin-left: 20px;
  margin-bottom: 16px;
  list-style-type: disc;
}

ul ul {
  margin-top: 8px;
  margin-bottom: 8px;
}

li {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 8px;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title) {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  background-color: #d2b48c !important;
  border: 1px solid #d2b48c !important;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon) {
  color: #ffffff !important;
}

:deep(.v-expansion-panel-text) {
  background-color: #f5f5dc !important;
  border: 1px solid #d2b48c !important;
  border-top: none !important;
}

#pricing-panel {
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .accordion-container {
    padding: 12px;
  }
  
  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }
}
</style>
